import { reauthenticate, resetReauthGuard } from './authConfig';

export function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // The token the SDK considered valid was rejected by the resource
                // server (revoked, scope change, clock skew). The SDK has no
                // force-refresh, so re-authenticate via a full login redirect.
                // reauthenticate() returns false if we already bounced through the
                // auth server moments ago — i.e. a fresh token isn't helping and
                // we'd otherwise loop, so surface a terminal error instead.
                const redirecting = reauthenticate();
                return Promise.reject(
                    redirecting
                        ? 'Your session has expired, redirecting to sign in'
                        : 'Unable to authenticate your session, please try again later'
                );
            } else if (response.status === 403) {
                // Notify user of no permission 403
                return Promise.reject('You are not authorised to perform this action');
            } else {
                const error = (data && data.message) ? data.message : 'An error occurred';
                return Promise.reject(error);
            }
        } else if (!data.success) {
            let error = (data && data.message) ? data.message : 'An error occurred';

            // If response has come from a device command, pull out the data and
            // reject with it so the caller can render the per-command results.
            if (data.response && Array.isArray(data.response)) {
                error = data.response;
            }

            return Promise.reject(error);
        } else {
            // A successful response proves auth is healthy — reset the loop guard
            // so a later genuine expiry can redirect immediately rather than
            // waiting out the window.
            resetReauthGuard();
            return Promise.resolve(data);
        }
    });
}
